import { csx } from '@vtex/admin-ui'

export const overlay = csx({
  zIndex: 9999,
  '.ant-tooltip-inner': {
    fontSize: '$detail',
    padding: '$space-2 $space-3',
  },
})
